'use strict';

const CollectionView = require('./collection');

const DateView = require('./date');

class DatesView extends CollectionView {
  tagName() {
    return 'ul';
  }

  constructor() {
    super(...arguments);
    this.on('select', this.select, this);
  }

  initialize() {
    this.setModule('glive_booking_redesign');
    this.childView = DateView;
  }

  attributes() {
    return { 'data-bhw': 'DatePicker' };
  }

  select(date) {
    this.options.selection = date;
    this.render();
  }
}

module.exports = DatesView;
